import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";
import GetProductTypeEnum from "../../../../types/productType";
import ErrorHandler from "../../../Helpers/Errors/ErrorHandler";
import IsMultiTerm from "../../Common/Helpers/IsMultiTerm";
import TobaccoUsage from "../../Common/Helpers/TobaccoUsage";

export const GetMCTQuotes = (basicInfo, healthClass = null, coverageAmount, term, setLoading, getIsSubscribed, setMultiTermResult = null, setQuoteResults = null, termStructure, quoteResultTermStructure = null, setQuoteLogId = null, isActivePurl, skipErrorLog, isAnchoringEnabled, utmQuoterProductId, setDisplayedAnchoredQuoteResult, isAmerico) => {
  const feet = basicInfo.height == null || basicInfo.height === '' ? 0 : basicInfo.height.split('ft')[0].trim();
  const inches = basicInfo.height == null || basicInfo.height === '' ? 0 : basicInfo.height.split('ft')[1].split('in')[0].trim();
  const weight = basicInfo.weight == null || basicInfo.weight === '' ? 0 : basicInfo.weight.split(' ')[0];
  const tobacco = TobaccoUsage(basicInfo.tobacco);
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const termAccountProduct = accountObj && accountObj.accountProducts.find(e => e.productTypeId === GetProductTypeEnum().FullUW);
  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

  const getQuotes = (customHealthClassResponse) => {
    const queryParams = {
      birthdate: basicInfo.birthdate || basicInfo.fakeBirthdate,
      state: basicInfo.state,
      gender: basicInfo.gender,
      faceAmount: coverageAmount,
      tobacco: tobacco,
      healthClass: customHealthClassResponse.defaultHealthClass,
      term: term,
      heightFt: feet,
      heightIn: inches,
      weight: weight,
      oneClickAccountId: accountObj.account.oneClickAccountId,
      replacePolicy: false,
      noKnockouts: customHealthClassResponse.isQualifiedForDigital,
      sessionId: accountObj.sessionId,
      isLevelTerm: (termStructure && termStructure.length > 0 && termStructure.includes('Level')) || false,
      isDecreasingTerm: (termStructure && termStructure.length > 0 && termStructure.includes('Decreasing')) || false,
      productRateCeilings: accountObj.account.productRateCeilings,
    };

    fetch(`${covrServicesUrl}/api/MCT/GetMCTQuote`, {
      method: 'POST',
      headers: {
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(queryParams),
    })
      .then((res) => res.json())
      .then((data) => {
        if (getIsSubscribed()) {
          if (data && data.quoteLogId && setQuoteLogId) {
            setQuoteLogId(data.quoteLogId)
          }
          const quoteResults = data && data.quoteResults;
          if (quoteResults && quoteResults.length) {

            let quotesList = quoteResults.map(qr => ({
              ...qr,
              isAnchoredProduct: String(qr.productID ?? '') === String(utmQuoterProductId ?? '')
            }));

            if (isAnchoringEnabled && !isAmerico) {
              const anchoredProduct = quotesList.filter(qr => qr.isAnchoredProduct);
              setDisplayedAnchoredQuoteResult(anchoredProduct);
              quotesList = quotesList.filter(qr => !qr.isAnchoredProduct);
            }

            if (setQuoteResults) {
              // Perform sort
              const sortedQuotes = quotesList.sort((a, b) => a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore);
              setQuoteResults(healthClass ? sortedQuotes : sortedQuotes[0]);
            }

            if (quoteResultTermStructure && setMultiTermResult && !quoteResultTermStructure.multiTerm) {
              setMultiTermResult(IsMultiTerm(data));
            }
          } else {
            if (setQuoteResults) setQuoteResults([]);
          }
        }
      })
      .catch((error) => {
        if (getIsSubscribed()) {
          if (!skipErrorLog) {
            ErrorHandler(error, setQuoteResults);
          }
          else {
            setQuoteResults([]);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  if ((feet !== 0 && inches !== 0 && weight !== 0 && tobacco !== undefined) || isActivePurl) {

    if (healthClass) {
      const customObj = {
        defaultHealthClass: healthClass,
        isQualifiedForDigital: true,
      }
      getQuotes(customObj);
    } else {
      setLoading(true);
      const basicInfoObj = {
        birthdate: basicInfo.birthdate,
        gender: basicInfo.gender,
        height: basicInfo.height,
        state: basicInfo.state,
        tobacco: basicInfo.tobacco,
        usResident: true,
        weight: basicInfo.weight,
      }
      fetch(`${covrServicesUrl}/api/VSS/GetCustomHealthClass`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ aboutMe: basicInfoObj }),
      })
        .then(res => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error('Error fetching custom health class');
          }
        })
        .then(customHealthClassResponse => {
          getQuotes(customHealthClassResponse)
        })
        .finally(() => {
          setLoading(false);
        });
    }
  } else {
    setLoading(false);
  }
}
